import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { enMessages } from "Languages/locales/en_US";
import { faMessages } from "Languages/locales/fa_IR";
import { read } from "Helpers/LocalStorage";

i18n.use(initReactI18next)
.init({
    lng: read('internalLanguage') ? read('internalLanguage') : 'fa',
    fallbackLng: "fa",
    interpolation: {
        escapeValue: false,
    },
    resources:{
        en: {
            translation: enMessages,
        },
        fa: {
            translation: faMessages,
        },
    },
});
export default i18n;